import { render, staticRenderFns } from "./user-group-list-card.vue?vue&type=template&id=3550edf8&scoped=true"
import script from "./user-group-list-card.vue?vue&type=script&lang=js"
export * from "./user-group-list-card.vue?vue&type=script&lang=js"
import style0 from "./user-group-list-card.vue?vue&type=style&index=0&id=3550edf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3550edf8",
  null
  
)

export default component.exports